export default __webpack_public_path__ + "static/media/social-instagram.61fa276a.svg";